/* Ocean Racing product page helpers (ntd-product.js), 2026-10-06.
   1. Add-on follow-up: when Dawn's product form finishes adding the main item (cartUpdate from product-form) and
      the add-on checkbox (outside the form, form="NtdAddonForm") is checked, add that variant too with the same
      sections render, then re-render the drawer once more. The checkbox never submits through Dawn's form.
   2. Pack fix (from the Mackinaw template): when the selected Color does not exist for the selected Pack (e.g.
      "One of each" after switching back to One pair), Dawn shows Unavailable; pick the first Color that exists. */
(function () {
  if (window.__ntdProductInit) return;
  window.__ntdProductInit = true;

  /* ---- add-on follow-up ---- */
  function checkedAddon() {
    var box = document.querySelector('input[data-ntd-addon-variant]:checked');
    return box ? box.getAttribute('data-ntd-addon-variant') : null;
  }
  function drawer() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }
  function addAddon(variantId) {
    var d = drawer();
    var sections = d && typeof d.getSectionsToRender === 'function' ? d.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var body = { items: [{ id: Number(variantId), quantity: 1 }], sections: sections, sections_url: window.location.pathname };
    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) return; // Shopify error (e.g. sold out): leave the main item in the cart, say nothing
        if (d && typeof d.renderContents === 'function') d.renderContents(state);
        var box = document.querySelector('input[data-ntd-addon-variant]:checked');
        if (box) box.checked = false;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ntd-addon', cartData: state });
        }
      })
      .catch(function () {});
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      var id = checkedAddon();
      if (id) addAddon(id);
    });
  }

  /* ---- pack fix ---- */
  function hidden(input) {
    return input.classList.contains('disabled') || input.classList.contains('visually-disabled');
  }
  function fixPack() {
    var selects = document.querySelector('variant-selects');
    if (!selects) return;
    selects.querySelectorAll('fieldset').forEach(function (fieldset) {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      if (!checked || !hidden(checked)) return;
      var inputs = fieldset.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        if (!hidden(inputs[i])) { inputs[i].click(); return; }
      }
    });
  }
  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(fixPack, 60);
  }).observe(document.body, { childList: true, subtree: true });
  fixPack();
})();
